// Antispam field
$(document).ready(function(){    
    $('form').submit(function(event){               
        var form = $(this);       
        
        form.find('input[type="hidden"][name="who"]').remove();
        form.prepend('<input type="hidden" name="who" value="human">');        
        
        form.find('input[type="hidden"][name="rand"]').remove();        
        var rand = Math.ceil(Math.random()*10000000);
        form.prepend('<input type="hidden" name="rand" value="'+rand+'">');        
    });
});